<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="ui form" [formGroup]="appConfigForm">
      <div class="field" [ngClass]="displayFieldCss('appConfigId')">
        <label>Configuration Title</label>
        <input
          formControlName="appConfigId"
          type="text"
          placeholder="Enter configuration title"
        />
        <app-field-error-display
          [displayError]="isFieldValid('appConfigId')"
          errorMsg="Please enter configuration title"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('appConfigDescription')">
        <label>Description </label>
        <textarea
          formControlName="appConfigDescription"
          rows="2"
          placeholder="Enter description"
        ></textarea>
        <app-field-error-display
          [displayError]="isFieldValid('appConfigDescription')"
          errorMsg="Please enter description"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('appConfigValue')">
        <label>Value</label>
        <textarea
          formControlName="appConfigValue"
          *ngIf="appConfig?.appConfigId !== 'TWO_FACTOR_AUTH_ACTIVATION_DATE'"
          rows="2"
          placeholder="Enter value"
        ></textarea>
        <div
          class="ui right icon input"
          *ngIf="appConfig?.appConfigId === 'TWO_FACTOR_AUTH_ACTIVATION_DATE'"
        >
          <i class="calendar icon"></i>
          <input
            type="text"
            formControlName="appConfigValue"
            suiDatepicker
            pickerPlacement="top left"
            [pickerMode]="mode"
            placeholder="Enter value"
          />
        </div>
        <app-field-error-display
          [displayError]="isFieldValid('appConfigValue')"
          errorMsg="Please enter value"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('possibleValues')">
        <label>Possible Values</label>
        <textarea
          formControlName="possibleValues"
          rows="2"
          placeholder="Enter possible values"
        ></textarea>
        <app-field-error-display
          [displayError]="isFieldValid('possibleValues')"
          errorMsg="Please enter possible values"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('isAvailableToOrg')">
        <sui-checkbox formControlName="isAvailableToOrg"
          >Is Available To Org
        </sui-checkbox>
        <app-field-error-display
          [displayError]="isFieldValid('isAvailableToOrg')"
          errorMsg="This field is required"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('isAvailableToUser')">
        <sui-checkbox formControlName="isAvailableToUser">
          Is Available To User
        </sui-checkbox>
        <app-field-error-display
          [displayError]="isFieldValid('isAvailableToUser')"
          errorMsg="This field is required"
        >
        </app-field-error-display>
      </div>

      <div
        class="field"
        [ngClass]="displayFieldCss('availableToApplicationUser')"
      >
        <sui-checkbox formControlName="availableToApplicationUser">
          Is Available To Application User
        </sui-checkbox>
        <app-field-error-display
          [displayError]="isFieldValid('availableToApplicationUser')"
          errorMsg="This field is required"
        >
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending"
    (click)="submit()"
    autofocus
  >
    {{ modal.context.isEdit ? "Edit" : "Add" }} Configuration
  </button>
</div>
